import React from 'react';
import { Input, Tag, Button, Icon } from 'antd';
import moment from 'moment';
import NoRecentSearch from '../../assets/svg/no_recent_Search.svg';
import { MInput } from '../Input/index';
import LastSearchIcon from '../../Svgs/LastSearchIcon';
import Popover from '@material-ui/core/Popover';
// import Button from '@material-ui/core/Button';
import searchIcon from '../../assets/svg/Path.svg';
import CrossIcon from '../../Svgs/CrossIcon';
import { FaSearch } from "react-icons/fa";
import service from '../../Contexts/SearchOrderItem/SearchOrderItemService';
import { withRouter } from 'react-router-dom';
import CustomSelect from './components/CustomSelect';
import SearchSku from './components/SearchSku';
import SearchPO from './components/SearchPO';
import SearchQty from './components/SearchQty';
import SearchColor from './components/SearchColor';
import SearchVendor from './components/SearchVendor';
import constants from '../../utils/constants';
import { IoMdCloseCircle } from 'react-icons/io';
import { SearchOrderItemContext, SET_SEARCH_TEXT, SET_SEARCH_OBJ } from '../../Contexts/SearchOrderItem/SearchOrderItemContext';
import CategoryFilter from './styles/CategoryFilter';
import '../../assets/styles/global.scss';
import './styles/searchBar.scss';

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            historyFlag: true,
            skuFlag: false,
            poFlag: false,
            qtyFlag: false,
            colorFlag: false,
            vendorFlag: false,
            manufacturerFlag: false,
            categoryFlag: false,
            open: false,
            sku: null,
            po: null,
            qty: null,
            minQty: null,
            maxQty: null,
            color: null,
            vendor: null,
            manufacturer: null,
            category: [],
            categoryData: [],

            setValue: false,

            search: null,
            disableSearchBtn: true,

            searchHistory: [],
        }
    }

    static contextType = SearchOrderItemContext;


    componentDidMount() {

        const searchHistory = JSON.parse(localStorage.getItem("global-search-history"));
        if (searchHistory) {
            this.setState({ searchHistory: searchHistory });
        }
    }

    componentWillUnmount() {
        this.setState({
            anchorEl: null,
            historyFlag: true,
            skuFlag: false,
            poFlag: false,
            qtyFlag: false,
            colorFlag: false,
            vendorFlag: false,
            manufacturerFlag: false,
            categoryFlag: false,
            open: false,

            sku: null,
            po: null,
            qty: null,
            minQty: null,
            maxQty: null,
            color: null,
            vendor: null,
            manufacturer: null,
            category: [],
            categoryData: [],

            setValue: false,

            search: null,
            disableSearchBtn: true,

            searchHistory: [],
        });
    }

    setAllState = (state, value) => {
        this.setState({ [state]: value })
    }

    handleClick = event => {
        this.setAllState("anchorEl", event.currentTarget);
    };

    handleClose = () => {
        this.setAllState("anchorEl", null);
    };

    applySearch = () => {
        const {
            sku,
            po,
            minQty,
            maxQty,
            color,
            vendor,
            categoryData,
            search,
            searchHistory
        } = this.state;

        let SearchObj = {};
        let tempSearchHistory = searchHistory;
        // if (!this.props.type) {
        this.setState({ anchorEl: null });

        if (search) SearchObj['search'] = search;
        // }
        if (sku) SearchObj['sku'] = sku;
        if (po) SearchObj['po'] = po;
        if (minQty) SearchObj['minQty'] = minQty;
        if (maxQty) SearchObj['maxQty'] = maxQty;
        if (color) SearchObj['color'] = color;
        if (vendor) SearchObj['vendor'] = vendor;
        if (categoryData && categoryData.length > 0) SearchObj['category'] = categoryData;
        SearchObj['timestamp'] = moment.utc().format();
        if (searchHistory && searchHistory.length > 3) {
            tempSearchHistory = searchHistory.slice(0, 3);
        }
        this.setState({ searchHistory: [SearchObj, ...tempSearchHistory] }, () => {
            localStorage.setItem("global-search-history", JSON.stringify(this.state.searchHistory));
        });
        if (this.props.type) {                          // this section is for Parking lot link item modal search
            this.setState({ setValue: true })
            this.props.onSearchPress(SearchObj, false)
        }
        else {
            this.context.dispatch({ type: SET_SEARCH_OBJ, searchObj: SearchObj });
            service.setSearchTextData(SearchObj.search, this.context);
            if (this.props.history.location.pathname !== '/searchedRecords') {
                this.props.history.push('/searchedRecords');
            }

        }
    }

    onSearchClear = () => {
        this.setState({ search: null })
        this.setState({ anchorEl: null });
        if (this.props.type) {                                        // this section is for Parking lot link item modal search
            this.props.onSearchPress('search', true)
            this.setState({ setValue: false });
        }
        else {

            service.setSearchTextData(null, this.context)

            if (this.props.history.location.pathname !== '/searchedRecords') {
                this.props.history.push('/searchedRecords');
            }
            // this.props.searchCtx.dispatch({ type: SET_SEARCH_TEXT, searchText: null })
        }
    }

    onPreviousSearchClick = (history) => {
        let searchObj = null
        const temphistory = this.state.searchHistory;
        this.setState({ anchorEl: null });

        if (this.props.type) {
            if (history.search) {                                              // this section is for Parking lot link item modal search
                this.setState({ search: history.search, setValue: true });
            }
            else {
                this.setState({ search: null, setValue: false });
            }
            this.props.onSearchPress(history, false)
        }
        else {
            temphistory.forEach(function (item, i) {
                if (item.timestamp === history.timestamp) {
                    temphistory.splice(i, 1);
                    item['timestamp'] = moment.utc().format();;
                    temphistory.unshift(item);
                    searchObj = item;
                }
            });
            localStorage.setItem("global-search-history", JSON.stringify(temphistory));
            this.context.dispatch({ type: SET_SEARCH_OBJ, searchObj: searchObj })

            if (searchObj.search) {
                service.setSearchTextData(searchObj.search, this.context)
            }
            if (this.props.history.location.pathname === '/searchedRecords') {
                this.setState({ anchorEl: null });
            }
            else {
                this.props.history.push('/searchedRecords');
            }
        }
    }

    setAll = (history, Sku, PO, Qty, Color, Vendor, Category) => {
        this.setAllState("historyFlag", history);
        this.setAllState("skuFlag", Sku);
        this.setAllState("poFlag", PO);
        this.setAllState("qtyFlag", Qty);
        this.setAllState("colorFlag", Color);
        this.setAllState("vendorFlag", Vendor);
        this.setAllState("categoryFlag", Category);
    }

    contentToShow = content => {
        const {
            skuFlag,
            poFlag,
            qtyFlag,
            colorFlag,
            vendorFlag,
            categoryFlag
        } = this.state;
        switch (content) {
            case "sku":
                if (skuFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, true, false, false, false, false, false);
                break;
            case "po":
                if (poFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, false, true, false, false, false, false);
                break;
            case "qty":
                if (qtyFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, false, false, true, false, false, false);
                break;
            case "color":
                if (colorFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, false, false, false, true, false, false);
                break;
            case "vendor":
                if (vendorFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, false, false, false, false, true, false);
                break;
            case "category":
                if (categoryFlag)
                    this.setAll(true, false, false, false, false, false, false);
                else
                    this.setAll(false, false, false, false, false, false, true);
                break;
            default:
                this.setAll(true, false, false, false, false, false, false);
                break;
        }
    }

    setCategory = category => {
        const tempCategory = category.map(cat => {
            let catTemp = cat === "Others" ? "Other" : cat;
            const findData = constants.GLOBAL_SEARCH_CATEGORY_LIST.find(element => element.label === catTemp);
            return findData.value;
        });
        this.setState({ category: category, categoryData: tempCategory });
    }

    setQty = qty => this.setState({ minQty: qty.minQty, maxQty: qty.maxQty });
    closeFilter = (state, value) => {
        this.setAll(true, false, false, false, false, false, false);
    }
    handleSearch = event => {
        const { value } = event.target;
        this.setState({
            search: value,
        });
    }
    getTimeDifference = timestamp => {
        let timeStampCal = null;
        let ctime = moment(moment.utc().format());
        const difference = moment.duration(ctime.diff(timestamp));
        let min = difference.minutes();
        let hour = difference.hours();
        let seconds = difference.seconds();
        let days = difference.days();
        let weeks = difference.weeks();
        let months = difference.months();
        let years = difference.years();
        if (years > 0)
            if (years === 1)
                timeStampCal = `One year ago`;
            else
                timeStampCal = `${years} years ago`;
        if (months > 0)
            if (months === 1)
                timeStampCal = `One month ago`;
            else
                timeStampCal = `${months} months ago`;
        else if (weeks > 0)
            if (weeks === 1)
                timeStampCal = `One week ago`;
            else
                timeStampCal = `${weeks} weeks ago`;
        else if (days > 0)
            if (days === 1)
                timeStampCal = `One day ago`;
            else
                timeStampCal = `${days} days ago`;
        else {
            if (hour > 0) {
                if (hour === 1)
                    timeStampCal = `One hour ago`;
                else
                    timeStampCal = `${hour} hours ago`;
            }
            else if (min) {
                if (min === 1)
                    timeStampCal = `One minute ago`;
                else
                    timeStampCal = `${min} minutes ago`;
            }
            else if (seconds) {
                if (seconds === 1)
                    timeStampCal = `One second ago`;
                else
                    timeStampCal = `${seconds} seconds ago`
            }
        }
        return timeStampCal;
    }
    render() {
        const {
            anchorEl,
            skuFlag,
            poFlag,
            qtyFlag,
            colorFlag,
            vendorFlag,
            categoryFlag,
            historyFlag,
            sku,
            po,
            minQty,
            maxQty,
            color,
            vendor,
            category,

            disableSearchBtn,
            search,

            setValue,
            searchHistory,
        } = this.state;

        const { history, type, isFromOrder } = this.props;
        const btnSearchClass = history && history.location && history.location.pathname.includes('parkinglotdetail') ? "general-menu-button-search-old" : "general-menu-button-search";

        if (po || minQty || maxQty || color || vendor || category.length > 0 || search) {
            if (disableSearchBtn === true) {
                this.setState({ disableSearchBtn: false })
            }
        }
        else if (disableSearchBtn === false) {
            this.setState({ disableSearchBtn: true })
        }
        const open = this.state.anchorEl === null ? false : true;
        const id = this.state.open ? 'simple-popover' : undefined;
        return (
            <div>
                {/* <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
                Open Popover
      </Button> */}
                {/* value={searchHistory.length > 0 && searchHistory[0].search} */}
                {type || isFromOrder ?
                    <Button className={`${btnSearchClass} ${this.props.className && this.props.className}`} onClick={this.handleClick}><FaSearch size={16} /></Button>
                    : <Input className='search-bar-outer' value={this.props.history.location.pathname.includes('/itemdetails') ? null : this.context.searchText} placeholder={"Search Items"} onClick={this.handleClick}
                        prefix={<img src={searchIcon} width={14} height={14} style={{ color: 'lightgrey' }} />}
                        suffix={this.context.searchText && !this.props.history.location.pathname.includes('/itemdetails') && <div className="searchbar-cross-icon"><IoMdCloseCircle onClick={this.onSearchClear}
                        /></div>}
                    />}

                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    className={type ? 'search-bar-dropdown-type' : "search-bar-dropdown"}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <div className="flex">
                        <Input className='search-bar-inner' value={search} placeholder="Search Items" onChange={e => this.handleSearch(e)}
                            suffix={this.props.type && setValue && <div className="searchbar-cross-icon"><IoMdCloseCircle onClick={this.onSearchClear} /></div>}
                        />
                        <div className="cancel-text"><p onClick={e => this.handleClose(e)}>Cancel</p></div>
                    </div>
                    <div className="flex-n-wrap">
                        {/* <Tag className={skuFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("sku")} >SKU</Tag> */}
                        <Tag className={po ? "applied-chip" : poFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("po")} >PO#</Tag>
                        <Tag className={minQty && minQty.length > 0 ? "applied-chip" : qtyFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("qty")} >Qty</Tag>
                        <Tag className={color ? "applied-chip" : colorFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("color")} >Color</Tag>
                        <Tag className={vendor ? "applied-chip" : vendorFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("vendor")} >Vendor</Tag>
                        <Tag className={category.length > 0 ? "applied-chip" : categoryFlag ? "selected-chip" : "chip"} onClick={() => this.contentToShow("category")} >Category</Tag>
                    </div>

                    <>
                        {
                            historyFlag && (
                                <div className="search-history">
                                    {
                                        searchHistory && searchHistory.length > 0 ? searchHistory.map((obj, index) => {
                                            let timeStampCal = this.getTimeDifference(obj.timestamp);
                                            return (
                                                <div key={index} className="recent-search" onClick={() => this.onPreviousSearchClick(obj)}>
                                                    <div className="searched-icon"><LastSearchIcon /></div>
                                                    <div className="search-section">
                                                        <div className="searched-text flex-space-inbetween">
                                                            {obj.search ? <div>{obj.search}</div> :
                                                                <>  {obj.sku && obj.sku.length > 0 && <Tag className="searched-chip">{obj.sku}</Tag>}
                                                                    {obj.po && obj.po.length > 0 && <Tag className="searched-chip">{obj.po}</Tag>}
                                                                    {obj.minQty && obj.minQty.length > 0 && <Tag className="searched-chip">{obj.minQty} - {obj.maxQty}</Tag>}
                                                                    {obj.color && obj.color.length > 0 && <Tag className="searched-chip">{obj.color}</Tag>}
                                                                    {obj.vendor && obj.vendor.length > 0 && <Tag className="searched-chip">{obj.vendor}</Tag>}
                                                                    {obj.category && obj.category.length > 0 && <Tag className="searched-chip">{obj.category.length > 1 ? obj.category[0] + ` +${obj.category.length - 1} more` : obj.category[0]}</Tag>}
                                                                </>
                                                            }
                                                            <div className="timestamp-section">{timeStampCal}</div>
                                                        </div>
                                                        {obj.search ? <>
                                                            {obj.sku && obj.sku.length > 0 && <Tag className="searched-chip">{obj.sku}</Tag>}
                                                            {obj.po && obj.po.length > 0 && <Tag className="searched-chip">{obj.po}</Tag>}
                                                            {obj.minQty && obj.minQty.length > 0 && <Tag className="searched-chip">{obj.minQty} - {obj.maxQty}</Tag>}
                                                            {obj.color && obj.color.length > 0 && <Tag className="searched-chip">{obj.color}</Tag>}
                                                            {obj.vendor && obj.vendor.length > 0 && <Tag className="searched-chip">{obj.vendor}</Tag>}
                                                            {obj.category && obj.category.length > 0 && <Tag className="searched-chip">{obj.category.length > 1 ? obj.category[0] + ` +${obj.category.length - 1} more` : obj.category[0]}</Tag>}
                                                        </> : null}
                                                    </div>
                                                </div >
                                            )
                                        }) : <div className="no-search-found-bar">
                                                <img src={NoRecentSearch} width="160" height="160" alt="No Recent Search Found" />
                                                <div className="m-t-20" style={{ textAlign: "center" }}>
                                                    <b style={{ fontSize: '16px' }}>Search for an item.</b>
                                                    <p>Search items by any of the attributes of an item.</p>
                                                </div>
                                            </div>
                                    }
                                </div >)
                        }
                    </>
                    <div className="button-section">
                        <Button className="button-green" disabled={disableSearchBtn} onClick={() => {
                            this.applySearch();
                        }}>Search</Button>
                    </div>
                    {/* <SearchSku show={skuFlag} parrentState={sku} setParent={this.setAllState} closeFilter={this.closeFilter} /> */}
                    <SearchPO show={poFlag} parrentState={po} setParent={this.setAllState} closeFilter={this.closeFilter} />
                    <SearchQty show={qtyFlag} minQtyP={minQty} maxQtyP={maxQty} setParent={this.setQty} closeFilter={this.closeFilter} />
                    <SearchColor show={colorFlag} parrentState={color} setParent={this.setAllState} closeFilter={this.closeFilter} />
                    <SearchVendor show={vendorFlag} parrentState={vendor} setParent={this.setAllState} closeFilter={this.closeFilter} />
                    <CategoryFilter>
                        {
                            categoryFlag && (
                                <CustomSelect show={categoryFlag} filters={category} setFilter={this.setCategory} closeFilter={this.closeFilter} />
                            )
                        }
                    </CategoryFilter>
                </Popover >
            </div >
        );
    }
}

export default withRouter(SearchBar);